import { IconButton, Paper, Stack, Typography } from '@mui/material';
import { Box, styled } from '@mui/system';

export default function Details({ children, title, toggle, actions, open, onDelete, onEdit }) {
    return (
        open && (
            <Container sx={{ display: { xs: 'block', sm: 'none' } }}>
                <Header>
                    <Stack direction="row" justifyContent="space-between" sx={{ width: '100%' }}>
                        <Stack direction="row" alignItems="center">
                            <IconButton sx={{ pl: 0, justifyContent: 'start', width: '30px' }} onClick={toggle}>
                                arrow_back
                            </IconButton>
                            <Typography sx={{ pl: 1, fontSize: theme => theme.typography.pxToRem(20), lineHeight: '28px', letterSpacing: '0.15px' }}>{title}</Typography>
                        </Stack>
                        {actions}
                    </Stack>
                    <div>
                        {onEdit && <IconButton onClick={onEdit}>edit</IconButton>}
                        {onDelete && (
                            <IconButton onClick={onDelete} sx={{ pl: 2 }}>
                                delete
                            </IconButton>
                        )}
                    </div>
                </Header>
                <div>{children}</div>
            </Container>
        )
    );
}

const Container = styled(Paper)(() => ({
    position: 'absolute',
    top: '64px',
    left: 0,
    padding: '16px 12px',
    height: '100%',
    width: '100%',
    backgroundColor: 'white',
    zIndex: 9
}));

const Header = styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'space-between'
}));
